import { Sim } from './simulation';
import { Diorama } from './three/Diorama';

export interface BootedGame {
  diorama: Diorama;
  canvas: HTMLCanvasElement;
}

/**
 * Mount a three.js voxel diorama into the given DOM container.
 *
 * The Diorama owns the canvas, scene, camera, and the per-frame sim tick.
 * Caller drives `diorama.update(dt)` from rAF and handles `resize` itself.
 */
export function bootGame(parentId: string, sim: Sim): BootedGame {
  const parent = document.getElementById(parentId);
  if (!parent) throw new Error(`bootGame: #${parentId} not found`);
  // Clear anything inherited from the old Phaser mount.
  parent.innerHTML = '';

  const canvas = document.createElement('canvas');
  canvas.style.display = 'block';
  canvas.style.width = '100%';
  canvas.style.height = '100%';
  parent.appendChild(canvas);

  const diorama = new Diorama(canvas, sim);

  window.addEventListener('resize', () => {
    diorama.resize(window.innerWidth, window.innerHeight);
  });

  return { diorama, canvas };
}
